module.exports = __webpack_public_path__ + "img/logo-fael.fcc86bed.png";